export function generateSlug(name: string): string {
  const slug = name
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '')
  return '/' + slug
}

export function ensureUniqueSlug(
  slug: string,
  pages: { id: string; slug: string }[],
  excludeId?: string
): string {
  const taken = new Set(pages.filter((p) => p.id !== excludeId).map((p) => p.slug))
  if (!taken.has(slug)) return slug
  let i = 2
  while (taken.has(`${slug}-${i}`)) i++
  return `${slug}-${i}`
}
